import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

// export const graphStyle = style({
//   aspectRatio: "5.5/3",
// });

export const timelineScrollPaneStyle = style({
  maxHeight: rem(216),
});
